module.exports = __webpack_public_path__ + "static/media/41.af6de30c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/41.png
// module id = 613
// module chunks = 0